module.exports = __webpack_public_path__ + "media/images/user/favicons/apple-touch-icon-114x114-71884239bdee6ca38409a20bd5b739c0.png";